import React from 'react';
import { message, Tabs } from 'antd';
import { connect } from 'react-redux';
import { login, signup, resend, resetPassword } from '../actions/user';
import LoginForm from '../components/LoginForm';
import SignupForm from '../components/SignupForm';
import logo from '../assets/images/image_logo_new.png';
import AppleSigninButton from '../components/AppleSigninButton';
import FBLoginButton from '../components/FBLoginButton';
import LineSigninButton from '../components/LineSigninButton';
import Config from '../config';
import * as R from 'ramda';
import ResetForm from '../components/ResetForm';

const { TabPane } = Tabs;

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoginForm: true,
            isResetForm: false,
            isResend: false,
        }

        this.handleOnResendSubmit = this.handleOnResendSubmit.bind(this);
        this.handleOnResetSubmit = this.handleOnResetSubmit.bind(this);
        this.handleOnResetMenu = this.handleOnResetMenu.bind(this);
        this.handleOnSignup = this.handleOnSignup.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.handleLoginMenu = this.handleLoginMenu.bind(this);
        this.handleSignupMenu = this.handleSignupMenu.bind(this);
        this.handleOnTabs = this.handleOnTabs.bind(this);
    }

    componentDidUpdate(prevProps) {
        const prevSessionToken = prevProps.response.data.sessionToken;
        const sessionToken = this.props.response.data.sessionToken;
        const refreshToken = this.props.response.data.sessionToken;

        if (R.isEmpty(prevProps.response.data)) {
            const { isLoginForm, isResetForm, isResend } = this.state;
            if (this.props.response.data.status === 'success') {
                if (!isLoginForm && !isResetForm) {
                    message.success('註冊成功!');
                    // 註冊成功後, 跳轉驗證信畫面
                    const email = encodeURIComponent(this.props.response.data.email);
                    window.location.assign(`/#/verify?email=${email}`);
                }

                if (isResetForm) {
                    // 發送忘記密碼成功
                    message.success('已發送重設密碼信');
                }

                if (isResend) {
                    message.success('已重新發送驗證信');
                    this.setState({
                        isResend: false,
                    })
                }

            } else if (this.props.response.data.status === 'fail') {
                const response = this.props.response.data.response;
                const { errors } = response.data;
                const msg = errors === undefined ? '更新失敗' : errors.message;
                message.error(msg);

            }
        }
        // 當 sessionToken 出現
        if (R.isNil(prevSessionToken) &&
            !R.isNil(sessionToken)) {
            window.location.assign(`${Config.thirdPartySignIn.redirectUrl}?status=SUCCESS&token=${sessionToken}&refresh=${refreshToken}`);
        }

    }

    handleOnSubmit(values) {
        this.setState({
            email: values.email,
        })
        this.props.login(values);
    }

    handleOnSignup(values) {
        this.props.signup(values);
    }

    handleOnResetSubmit(values) {
        this.props.resetPassword(values);
    }

    handleOnResendSubmit(values) {
        this.setState({
            isResend: true
        })
        this.props.resend(values);
    }

    handleLoginMenu() {
        this.setState({
            isLoginForm: true,
            isResetForm: false,
        });
    }

    handleSignupMenu() {
        this.setState({
            isLoginForm: false,
            isResetForm: false,
        });
    }

    handleOnTabs(key) {
        switch (key) {
            case "login":
                this.handleLoginMenu();
                break;

            case "register":
                this.handleSignupMenu();
                break;
            default:
                break;
        }
    }

    handleOnResetMenu() {
        this.setState({
            isResetForm: true,
        });
    }

    render() {
        const { isResetForm } = this.state;
        return (
            <div className="flex-center-center" style={{ height: '100vh' }}>
                <div style={{ textAlign: 'center' }}>
                    <img src={logo} alt="fitCloud" style={{ width: '70%' }} />
                    <Tabs defaultActiveKey="login" animated={false} onTabClick={this.handleOnTabs}>
                        <TabPane tab="登入" key="login" >
                            {isResetForm ?
                                <div style={{ margin: '30px 15px 0px 15px' }}>
                                    <p className="forgot-title">忘記密碼</p>
                                    <p className="verify-body">輸入您的信箱，我們將寄送重設密碼的連結給您。</p>
                                    <ResetForm onSubmit={this.handleOnResetSubmit}></ResetForm>
                                    <button className="link-btn" onClick={this.handleLoginMenu}
                                    >返回登入</button>
                                </div> :
                                <div>
                                    <div className="flex-center-center" style={{ marginTop: '30px' }}>
                                        <LoginForm onResend={this.handleOnResendSubmit} onReset={this.handleOnResetMenu} onSubmit={this.handleOnSubmit} isSubmitting={this.props.isSubmitting} response={this.props.response} />
                                    </div>

                                    <div className="separator" style={{ width: '80%' }}>或</div>

                                    <div className="buttons-flex-center-center">
                                        <FBLoginButton />
                                        <LineSigninButton />
                                        <AppleSigninButton />
                                    </div>
                                </div>
                            }
                        </TabPane>
                        <TabPane tab="註冊" key="register">
                            <div className="flex-center-center" style={{ marginTop: '30px' }}>
                                <SignupForm onSubmit={this.handleOnSignup} isSubmitting={this.props.isSubmitting} response={this.props.response} />
                            </div>
                            <div>
                                <span className="gr2-text">建立帳號即同意FitGames</span>
                                <a className="link-btn" href="https://fitgames.tw/helper/#about-part-4">服務條款</a>
                                <span className="gr2-text">及</span>
                                <a className="link-btn" href="https://fitgames.tw/helper/#about-part-6">隱私權政策</a>
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    response: state.user.submitResponse,
    isSubmitting: state.user.submitResponse.isSubmitting,
    isLogged: state.user.isLogged,
    socialLoginResponse: state.socialLogin.submitResponse,
    isSocialSubmitting: state.socialLogin.submitResponse.isSubmitting,
    isSocialLogged: state.socialLogin.isLogged,
    me: state.user.me,
    socialMe: state.socialLogin.me,
});

const mapDispatchToProps = {
    login,
    signup,
    resend,
    resetPassword,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login);
